import competitiveActivityList from '@/store/modules/competitive-activity/competitive-activity-list'
import competitiveActivityItem from '@/store/modules/competitive-activity/competitive-activity-item'
import competitiveActivityCreate from '@/store/modules/competitive-activity/competitive-activity-create'
import competitiveActivityDelete from '@/store/modules/competitive-activity/competitive-activity-delete'
import competitiveActivityKindSport from '@/store/modules/competitive-activity/competitive-activity-kind-sport'

export default {
  competitiveActivityList,
  competitiveActivityItem,
  competitiveActivityCreate,
  competitiveActivityDelete,
  competitiveActivityKindSport,
}
